import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Clock } from 'lucide-react';
import { contactInfo, openingHours, kitchenHours } from '../mock';

export default function Footer() {
  return (
    <footer className="bg-[#12100e] text-amber-100/80">
      <div className="max-w-7xl mx-auto px-6 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div>
          <div className="flex items-center gap-3 mb-4">
            <div className="w-11 h-11 rounded-full bg-gradient-to-br from-amber-400 to-amber-600 flex items-center justify-center font-bold text-[#1a1410]">KSV</div>
            <div>
              <div className="text-white font-serif text-lg">Sportkantine</div>
              <div className="text-amber-300/80 text-[10px] tracking-[0.3em] uppercase">Wien 1110</div>
            </div>
          </div>
          <p className="text-sm leading-relaxed">Authentische österreichische Küche im Herzen von Wien. Wir freuen uns auf Ihren Besuch!</p>
        </div>

        <div>
          <h4 className="text-white font-serif text-lg mb-4">Kontakt</h4>
          <ul className="space-y-3 text-sm">
            <li className="flex items-start gap-3"><MapPin size={16} className="mt-0.5 text-amber-400 shrink-0"/><span>{contactInfo.address}<br/>{contactInfo.city}, {contactInfo.country}</span></li>
            <li className="flex items-center gap-3"><Phone size={16} className="text-amber-400"/><a href={`tel:${contactInfo.phone}`} className="hover:text-amber-300">{contactInfo.phone}</a></li>
            <li className="flex items-center gap-3"><Mail size={16} className="text-amber-400"/><a href={`mailto:${contactInfo.email}`} className="hover:text-amber-300 break-all">{contactInfo.email}</a></li>
          </ul>
        </div>

        <div>
          <h4 className="text-white font-serif text-lg mb-4 flex items-center gap-2"><Clock size={18} className="text-amber-400"/> Öffnungszeiten</h4>
          <ul className="space-y-1.5 text-sm">
            {openingHours.map((o) => (
              <li key={o.day} className="flex justify-between gap-4">
                <span>{o.day}</span><span className="text-amber-200">{o.hours}</span>
              </li>
            ))}
          </ul>
          <div className="mt-4 pt-3 border-t border-white/10 text-xs">
            <div className="text-amber-300 uppercase tracking-widest text-[10px] mb-1">Küche</div>
            <div className="text-amber-100/80">{kitchenHours} Uhr</div>
          </div>
        </div>

        <div>
          <h4 className="text-white font-serif text-lg mb-4">Navigation</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/" className="hover:text-amber-300">Startseite</Link></li>
            <li><Link to="/ueber-uns" className="hover:text-amber-300">Über uns</Link></li>
            <li><Link to="/services" className="hover:text-amber-300">Services</Link></li>
            <li><Link to="/wochenmenue" className="hover:text-amber-300">Wochenmenü</Link></li>
            <li><Link to="/speisekarte" className="hover:text-amber-300">Speisekarte</Link></li>
            <li><Link to="/saisonkarte" className="hover:text-amber-300">Saisonkarte</Link></li>
            <li><Link to="/galerie" className="hover:text-amber-300">Galerie</Link></li>
            <li><Link to="/kontakt" className="hover:text-amber-300">Kontakt</Link></li>
            <li><Link to="/admin" className="text-white/40 hover:text-amber-300 text-xs">Admin</Link></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 py-5 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-amber-100/50">
          <span>© {new Date().getFullYear()} KSV-Sportkantine. Alle Rechte vorbehalten.</span>
          <span>KSV-Sportkantine · Wien</span>
        </div>
      </div>
    </footer>
  );
}
